import { type Review } from '@tmdb-graphql-api/schema/types';
import { type Config } from '../../../types.ts';
import { formatAvatarPath } from './formatAvatarPath.ts';

export const formatReview = (data: Review, { images }: Config) => {
  const { author, authorDetails, content, createdAt, id, mediaTitle } = data;
  const { avatarPath, rating, username } = authorDetails ?? {};

  return {
    author,
    avatarPath: formatAvatarPath(avatarPath, images),
    content,
    createdAt,
    id,
    mediaTitle,
    rating,
    username,
  };
};

export const formatReviews = (listings: Review[], config: Config) => listings.map(data => formatReview(data, config));
